function initSwiper({ swiperSelector, swiperOptions = {} }) {
  const sw = typeof swiperSelector === 'string'
    ? document.querySelector(swiperSelector)
    : swiperSelector;

  if (!sw) return null;
  const wrapper = sw.querySelector('.swiper-wrapper');

  const baseOptions = {
    speed: 500,
    preloadImages: false,
    lazy: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.5,
      momentumVelocityRatio: 1,
    },
    mousewheel: {
      forceToAxis: true,
      invert: false,
      sensitivity: 1,
    },
    observer: true,
    observeParents: true,
  };

  if (sw.swiper) destroySwiper(sw);

  const instance = new Swiper(sw, {
    ...baseOptions,
    ...swiperOptions,
  });

  return instance;
}

function hiddenSlides(swiper) {
  const isMobile = window.innerWidth < 800;
  const indexRemove = [];

  swiper.slides.forEach((slide, index) => {
    const hideOnMobile = slide.dataset.hideMobile === 'true';
    const hideOnDesktop = slide.dataset.hideDesktop === 'true';
    if ((isMobile && hideOnMobile) || (!isMobile && hideOnDesktop)) {
      indexRemove.push(index);
    }
  });

  if (!indexRemove.length) return;

  swiper.removeSlide(indexRemove);
  swiper.update();
}

function destroySwiper(sw) {
  if (!sw) return;
  if (sw.swiper) sw.swiper.destroy(true, true);
  return null;
}

/* Handle tab menu */
function initTabMenu(selector) {
    const activeClass = 'is-active';

    const tabMenu = document.querySelector(selector);
    if (!tabMenu) return;

    const heads = tabMenu.querySelectorAll('.tab-menu-head');
    const panels = tabMenu.querySelectorAll('.tab-menu-panel');

    if (!heads.length || !panels.length) return;

    function activateTab(targetId) {
    heads.forEach((head) => {
        const isTarget = head.dataset.target === targetId;

        head.classList.toggle(activeClass, isTarget);
    });

    panels.forEach((panel) => {
        const isTarget = panel.id === targetId;
        panel.classList.toggle(activeClass, isTarget);
    });
    }

    heads.forEach((head) => {
    head.addEventListener('click', () => {
        if (head.classList.contains(activeClass)) return;

        const targetId = head.dataset.target;
        if (!targetId) return;

        activateTab(targetId);
    });
    });
}

/* Handle tabmenu builder */
function initTabMenuBuilder(root) {
  const activeClass = 'is-active';
  if (typeof root === 'string') root = document.querySelector(root);
  if (!root) return;

  const getButtons = () => [
    ...root.querySelectorAll('[data-tab-heads] .button-style')
  ];

  const getPanels = () => [
    ...root.querySelectorAll('[data-tab-panel]')
  ];

  const activate = (index) => {
    const buttons = getButtons();
    const panels = getPanels();

    buttons.forEach((button, i) => {
      button.classList.toggle(activeClass, i === index);
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle(activeClass, i === index);
      panel.hidden = i !== index;
    });
  };

  if (root.dataset.tabBuilderBound !== 'true') {
    root.dataset.tabBuilderBound = 'true';

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tab-heads] .button-style');
      if (!button || !root.contains(button)) return;

      if (button.tagName === 'A') event.preventDefault();

      const buttons = getButtons();
      const index = buttons.indexOf(button);

      if (index >= 0) activate(index);
    });
  }

  root.__activateTabMenu = activate;

  if (root.dataset.tabBuilderBound !== 'true') {
    root.dataset.tabBuilderBound = 'true';

    root.addEventListener('click', (event) => {
      const button = event.target.closest('.button-style');
      const headWrap = root.querySelector('[data-tab-heads]');

      if (!button || !headWrap || !headWrap.contains(button)) return;

      event.preventDefault();

      const index = getButtons().indexOf(button);
      if (index >= 0) activate(index);
    });
  }

  activate(0);
}
